import { Button, useTheme } from "@mui/material";
import { Plus } from "lucide-react";
import { useState } from "react";
import type { JourneyCase } from "../dtos";
import CloneStepsDialog from "./clone-steps-dialog";
import { secondaryButtonSx } from "./field-shell";

/**
 * §Multi-application: start ANOTHER Nawy Now application on a lead that already has one — same crm-backend
 * route and permission as the empty-state "Start Nawy Now flow". A second application is a real, billable
 * piece of work (a new i-Score step, a new credit file), so the click opens `CloneStepsDialog` in START
 * mode rather than firing immediately — the dialog carries its own Cancel/Confirm and, per §Clone-steps,
 * the option to prefill the new application's steps from one of the lead's existing ones.
 */
const StartAnotherApplicationButton = ({
  customerUid,
  leadUid,
  cases,
  onStarted,
}: {
  customerUid: string;
  leadUid: string;
  /** every application on this lead, oldest first — feeds the dialog's "Copy from…" picker and labels */
  cases: JourneyCase[];
  onStarted: (caseUid: string) => void;
}) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        disableElevation
        onClick={() => setOpen(true)}
        startIcon={<Plus size={16} />}
        sx={{ ...secondaryButtonSx(theme), textTransform: "none" }}
      >
        Start another application
      </Button>
      <CloneStepsDialog
        open={open}
        onClose={() => setOpen(false)}
        mode="start"
        cases={cases}
        customerUid={customerUid}
        leadUid={leadUid}
        onStarted={onStarted}
      />
    </>
  );
};

export default StartAnotherApplicationButton;
